export default __webpack_public_path__ + "static/marc-laurant-024a3c50d88a5bd9357aa966fafd8286.jpeg";